import axios from 'axios';

// Determine API base URL based on environment
const getApiBaseUrl = () => {
  // In production, use the environment variable or default to current domain
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.host}/api`;
  }
  
  // In development, use environment variable or default to development port
  return process.env.REACT_APP_API_URL || 'http://localhost:8001/api';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const apiService = {
  // Contact form submission
  submitContact: (data) => {
    // Transform field names to match backend expectations
    const transformedData = {
      full_name: data.fullName,
      company: data.company,
      email: data.email,
      project_type: data.projectType,
      message: data.message
    };
    console.log('API Service - Original data:', data);
    console.log('API Service - Transformed data:', transformedData);
    console.log('API Service - Making request to:', '/contact/');
    return api.post('/contact/', transformedData);
  },
  
  // Get services
  getServices: () => api.get('/services/'),
  
  // Get solutions
  getSolutions: () => api.get('/solutions/'),
  
  // Get company stats
  getStats: () => api.get('/stats/'),
  
  // Get company info
  getCompanyInfo: () => api.get('/company/'),
  
  // Newsletter subscription
  subscribeNewsletter: (email) => api.post('/newsletter/', { email }),
};

export default api;
